import React, { Component } from "react"
import { navigate } from "gatsby-link"
import styled from "@emotion/styled"

const FormContainer = styled.form`
  display: grid;
  width: 100%;
  grid-gap: 24px;
  padding: 32px;
  box-shadow: ${props => props.theme.shadow.long};
  background: #ffffff;
  border-radius: 8px;
`

const TextInput = styled.input`
  margin-top: 8px;
  border-radius: 4px;
  padding: 16px 24px;
  font-size: 18px;
  color: ${props => props.theme.shade[0]};
  border: rgba(0, 0, 0, 0.2) 2px solid;
  outline: none;
  width: 100%;
  &:focus {
    border: ${props => props.theme.shade[0]} 2px solid;
  }
`
const TextAreaInput = styled.textarea`
  margin-top: 8px;
  border-radius: 4px;
  padding: 16px 24px;
  font-size: 18px;
  color: ${props => props.theme.shade[0]};
  box-shadow: none;
  border: rgba(0, 0, 0, 0.2) 2px solid;
  outline: none;
  width: 100%;
  &:focus {
    border: ${props => props.theme.shade[0]} 2px solid;
  }
`
const SubmitButton = styled.input`
  background: ${props => props.theme.primary};
  color: ${props => props.theme.shade[100]};
  padding: 12px 24px;
  border-radius: 4px;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  outline: none;
  border: none;
  max-width: 200px;
  cursor: pointer;
  &:hover {
    background: ${props => props.theme.shade[10]};
  }
`
const FormField = styled.div``
const Label = styled.label``

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

export default class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        ...this.state,
      }),
    })
      .then(() => navigate(form.getAttribute("action")))
      .catch(error => alert(error))
  }
  render() {
    return (
      <FormContainer
        name="Coming Soon Page"
        method="post"
        action="/thanks/"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={this.handleSubmit}
        data-sal="slide-up"
        data-sal-duration="900"
        data-sal-delay="300"
      >
        {/* eslint-disable */}
        <input
          aria-Label="Text Field"
          type="hidden"
          name="form-name"
          value="contact"
        />
        <div hidden>
          <input
            name="bot-field"
            aria-Label="Text Field"
            type="text"
            id="name-field"
            placeholder="Name"
            onChange={this.handleChange}
          />
        </div>
        {/*eslint-enable */}
        {/* Client Name */}
        <FormField>
          <Label htmlFor="name">Name</Label>
          <TextInput
            textColor={this.props.textColor}
            type="text"
            name="name"
            id="name"
            className="form__input"
            placeholder="Name"
            onChange={this.handleChange}
            required
          />
        </FormField>
        {/* Client Company */}
        <FormField>
          <Label htmlFor="company">Company</Label>
          <TextInput
            textColor={this.props.textColor}
            type="text"
            name="company"
            id="company"
            className="form__input"
            placeholder="Company"
            onChange={this.handleChange}
            required
          />
        </FormField>
        {/* Client Email */}
        <FormField>
          <Label htmlFor="email">Email</Label>
          <TextInput
            textColor={this.props.textColor}
            type="email"
            name="email"
            id="email"
            className="form__input"
            placeholder="Email Address"
            onChange={this.handleChange}
            required
          />
        </FormField>
        {/* Client Telephone */}
        <FormField>
          <Label htmlFor="telephone">Telephone</Label>
          <TextInput
            textColor={this.props.textColor}
            type="telephone"
            name="telephone"
            id="telephone"
            className="form__input"
            placeholder="Phone Number"
            onChange={this.handleChange}
            required
          />
        </FormField>
        {/* Client Message */}
        <FormField>
          <Label htmlFor="message">Message</Label>
          <TextAreaInput
            textColor={this.props.textColor}
            name="message"
            id="message"
            className="form__textarea"
            placeholder="How can we help?"
            onChange={this.handleChange}
          />
        </FormField>
        {/* Form submit button */}
        <SubmitButton type="submit" value="Submit" className="form__button" />
      </FormContainer>
    )
  }
}
